module.exports = __webpack_public_path__ + "img/void.99f11f13.jpg";